import { Button, Container, Content, Element, Form, Section } from 'react-bulma-components';
import { ContentTabs, Tab } from '../components';
import React, { Fragment, useEffect, useRef, useState } from 'react';
import { gql, useMutation, useQuery } from '@apollo/client';

import KeyTonicPicker from '../components/keytonic-picker';
import { Loader } from '../components';
import Markdown from '../components/markdown';
import MarkdownTextarea from '../components/markdown-textarea';
import MarkdownTextareaAC from 'components/markdown-textarea_ac';
import PageTitle from '../components/pagetitle';
import RevisionPicker from '../containers/revision-picker';
import ScoreMarks from 'components/scoremarks';
import SheetContainer from '../components/sheetcontainer';
import SortablePracticeStack from '../components/sortable-stack';
import StepContentEdit from '../components/step-content-edit';
import { Steps } from '../components';
import Switch from '../components/switch';
import _ from 'lodash';
import { cache } from 'cache';
import createMapper from 'map-factory';
import { faFileAudio } from '@fortawesome/free-regular-svg-icons';
import { faMusic } from '@fortawesome/free-solid-svg-icons';
import { navigate } from '@reach/router';
import { useForm } from '../hooks/formState';
import { useInView } from 'react-intersection-observer';

const { Control, Field, Input, InputFile, Label, Select } = Form;

const keepKeys = [
  "id",
  "type",
  "keytonic",
  "content",
  "refid",
  "title",
  "skipInstrumentTransponation",
  "slug",
  "description",
  "level",
  "revisionComment",
  "steps[].id",
  "steps[].keytonic",
  "steps[].title",
  "steps[].description",
  "steps[].explanation",
  "steps[].practice[].id",
  "steps[].practice[].title",
  "steps[].practice[].description",
  "steps[].practice[].keytonic",
  "steps[].practice[].refid",
  "steps[].practice[].allowUserKey",
  "steps[].scoremarks[].id",
  "steps[].scoremarks[].pos",
  "steps[].scoremarks[].a",
  "steps[].scoremarks[].b",
  "steps[].scoremarks[].to",
  "steps[].scoremarks[].bc"
]

const SONGREVISION_DEFINITION = gql`
    fragment SongRevision_Definition on SongRevision {
      id
      type
      keytonic
      content
      refid
      title
      skipInstrumentTransponation
      slug
      description
      level
      steps {
        id
        keytonic
        title
        description
        explanation
        practice{
          id
          title
          description
          keytonic
          refid
          audio
          allowUserKey
        }
        scoremarks{
          pos
          a
          b
          to
          bc
        }
      }
      stepids,
      revision {
        id
        saved 
        comment
      }
    }
  `;

const GET_SONGREVISION = gql`
  query GetSongRevision($slug: String!, $id: String) {
    songRevision(slug: $slug, id: $id){
      ...SongRevision_Definition
  }
}
${SONGREVISION_DEFINITION}
`;

const UPDATE_SONG = gql`
 mutation updateSong($slug: String!, $songRevision: SongRevisionInput!, $publish: Boolean){
  updateSong(slug: $slug, songRevision: $songRevision, publish: $publish)
  {
    success
    message
    published
    songRevision {
      ...SongRevision_Definition
    }
  }
}
${SONGREVISION_DEFINITION}
`;

const UNPUBLISH_SONG = gql`
 mutation unpublishSong($slug: String!){
  unpublishSong(slug: $slug)
  {
    success
    message
  }
}
`;

const SongEdit = ({ slug }) => {
 
  let scoremarksdata = { scoremarks:[
    { pos: "1:2", a: 'i', b: 'b9', bc: 'r'},
    { pos: "2:1", bc: 'b'},
    { pos: "2:2", bc: 'y'},
    { pos: "3:1", a: 'ii', b: '9,11,6', to: true},
    { pos: "4:1", to: true},
    { pos: "5:1", bc : 'o' },
    { pos: "6:1", bc: 'g'},
    { pos: "7:1", bc: 'r', b: '<C:F Bb:Eb Eb:Ab> Dorian'},
  ]};
  //const { values: scoremarks, handleChange: handleMarkChange, setInitialValues: setInitialMarkValues } = useForm((formValues) => submitForm(formValues), {});
  
  const { ref, inView, entry } = useInView({
    /* Optional options */
    threshold: 0,
  });
  const [currentRevisionId, setCurrentRevisionId] = useState();
  const [songSheetCursor, setSongSheetCursor] = useState('pointer');
  const [currentTab, setCurrentTab] = useState("Steps");
  const [currentStep, setCurrentStep] = useState(1);
  const [currentStepTab, setCurrentStepTab] = useState("Chord chart");
  const { data, loading, error } = useQuery(
    GET_SONGREVISION,
    {
      variables: { slug: slug, id: currentRevisionId },
      // fetchPolicy: "no-cache"
    }
  );
  const [updateSong, { loading: updateLoading, error: updateError }] = useMutation(UPDATE_SONG, {
    onCompleted(response) {

      alert(`Content ${response.published ? "published" : "saved"}`);
      setCurrentRevisionId(response.updateSong.songRevision.revision.id);
      evictSong();
      // TODO: keep tab states, possible?
    }
  });
  const evictSong = () => {
    const normalizedId = cache.identify({ slug: values.slug, __typename: 'Song' });
    cache.evict(normalizedId);
    cache.gc();
  }
  const [unpublishSong, { loading: unpublishLoading, error: unpublishError }] = useMutation(UNPUBLISH_SONG, {
    onCompleted(response) {
      alert(response.unpublishSong.message);
    }
  });

  const scoreMarksRef = useRef();
  const onChordClick = ( data ) => {
    scoreMarksRef.current.getEvents().onChordClick(data);
  }

  const { values, handleChange, setInitialValues, setValues } = useForm((formValues) => submitForm(formValues), {});
  const [valuesLoaded, setValuesLoaded] = useState(false);

  const cleanFormValues = () => {
    const mapper = createMapper();
    const options = { flatten: false };
    keepKeys.forEach((key, _) => {
      mapper.map(key).with(options).rejectIf(key, value => {
        if (typeof value == "boolean") {
          // always include booleans
          return false;
        }
        return value ? false : true;
      })
    });
    return mapper.execute(values);
  }

  const submitForm = null;
  const handleUnpublish = () => {
    var variables = {
      variables:
      {
        slug: values.slug
      }
    };
    unpublishSong(variables);
  }
  const handlePublish = () => {
    handleUpdateSong({ publish: true });
  }
  const handleSave = () => {
    handleUpdateSong({ publish: false });
  }
  const handleUpdateSong = ({ publish }) => {
    var variables = {
      variables:
      {
        slug: values.slug,
        songRevision: cleanFormValues(),
        publish: publish
      }
    };
    updateSong(variables);
  }

  const addPractice = () => {
    let fieldName = `steps[${currentStep - 1}].practice`;
    var arr = _.get(values, fieldName, []);
    if (!Array.isArray(arr)) arr = new Array();
    const result = [...arr];

    let practice = {
      collapsibleid: _.uniqueId('PracticeItem_'),
      title: "Practice title",
      description: "",
      audio: ""
    }

    result.push(practice);
    var e = new Object();
    e.target = {
      name: fieldName,
      value: result
    };
    handleChange(e, "array");
    //arraySetInitialValue('settings', {});

  }

  const deletePractice = (index) => {
    if (window.confirm('Are you really sure you want to delete this record?')) {
      let fieldName = `steps[${currentStep - 1}].practice`;
      var arr = _.get(values, fieldName);
      const result = [...arr];
      let i = result.splice(index, 1)[0];
      var e = new Object();
      e.target = {
        name: fieldName,
        value: result
      };

      handleChange(e, "array");
    }
  }

  const onDrop = (e) => {
    var newValues = applyDrag(_.get(values, `steps[${currentStep - 1}].practice`), e);
    e.target = {
      name: `steps[${currentStep - 1}].practice`,
      value: newValues
    };

    handleChange(e, "array");
  };
  const applyDrag = (arr, dragResult) => {
    const { removedIndex, addedIndex, payload } = dragResult;
    if (removedIndex === null && addedIndex === null) return arr;

    const result = [...arr];
    let itemToAdd = payload;

    if (removedIndex !== null) {
      itemToAdd = result.splice(removedIndex, 1)[0];
    }

    if (addedIndex !== null) {
      result.splice(addedIndex, 0, itemToAdd);
    }
    return result;
  };
  const addStep = () => {
    let fieldName = `steps`;
    var arr = _.get(values, fieldName, []);
    if (!Array.isArray(arr)) arr = new Array();
    const result = [...arr];

    let step = {
      keytonic: "",
      title: "",
      description: "",
      explanation: "",
      practice: [],
      scoremarks: []
    }

    result.push(step);
    var e = new Object();
    e.target = {
      name: fieldName,
      value: result
    };
    handleChange(e, "array");
    setCurrentStep(values.steps.length);
  }

  const handleStepOrder = (e) => {
    let selectedValue = parseInt(e.target.value);
    var newValues = applyDrag(_.get(values, `steps`), { removedIndex: currentStep - 1, addedIndex: selectedValue - 1 });
    e.target = {
      name: `steps`,
      value: newValues
    };

    handleChange(e, "array");
    setCurrentStep(selectedValue);
  }

  const deleteStep = () => {
    if (window.confirm('Are you really sure you want to delete this step?')) {
      let fieldName = "steps";
      var arr = _.get(values, fieldName);
      const result = [...arr];
      let i = result.splice(currentStep - 1, 1)[0];
      var e = new Object();
      e.target = {
        name: fieldName,
        value: result
      };

      handleChange(e, "array");
      setCurrentStep((currentStep < 2) ? 1 : currentStep - 1);
    }
  }

  const insertSongTemplate = () => {
    var e = new Object();
    e.target = {
      name: "content",
      value: '<instrument>\n\
  <C>\n\    <score format="text"></score>\n\  </C>\n\
  <Bb>\n\    <score format="text"></score>\n\  </Bb>\n\
  <Eb>\n\    <score format="text"></score>\n\  </Eb>\n\</instrument>'
    };
    handleChange(e);
  }

  const changeActiveTab = () => {
    if (currentTab === 0) setCurrentTab(1);
  }
  /*   const closeModal = () => {
      console.log("close modal");
      setShowPracticeDeleteModal(false);
    } */
  const chordChartRef = useRef(null);
  function pasteTemplate() {
    const areaRef = chordChartRef.current.getAreaRef();
    const ta = areaRef.current;
    let snippet = '<instrument>\n\
    <C>\n\    <score format="text"></score>\n\  </C>\n\
    <Bb>\n\    <score format="text"></score>\n\  </Bb>\n\
    <Eb>\n\    <score format="text"></score>\n\  </Eb>\n\</instrument>'
    ta.setRangeText(snippet)
    areaRef.current.selectionStart = areaRef.current.selectionEnd = areaRef.current.selectionStart; //Math.floor(snippet.length / 2);
    areaRef.current.focus();
  }

  useEffect(() => {

    //setInitialMarkValues(scoremarksdata);
    
    if (_.get(data, 'songRevision', false)) {
      setValues({});
      setInitialValues(_.cloneDeep(data.songRevision)); // Very important to make a deep clone! Otherwise, mutating arrays won't work.
      console.log("Set initial values");
      if (!data.songRevision) {
        return;
      }
      setCurrentRevisionId(data.songRevision.revision.id);
      if (currentStep > data.songRevision.steps.length) {
        setCurrentStep(data.songRevision.steps.length == 0 ? 1 : data.songRevision.steps.length);
      }
      setValuesLoaded(true);
    }
  }, [data]);

  if (loading) return (
    <Fragment>
      <PageTitle>
        <Loader />
      </PageTitle>
    </Fragment>
  );
  if (_.get(error, "graphQLErrors[0].extensions.code") === "FORBIDDEN") {
    return (
      <p>{error.message}</p>
    )
  }
  if (error) return <p>ERROR! {error.message}</p>;
  if (updateError) return <p>ERROR {updateError.message}</p>;
  if (!valuesLoaded) {
    return (
      <p>Initializing data</p>
    );
  }
  // TODO add generic 404-page
  if (!data.songRevision) {
    return (
      <p>Oops, resource not found</p>
    )
  }
  return (
    <Fragment>
      <PageTitle 
        name={values.title} 
        description={values.description} 
        color="danger" 
        isSong={values.type === "song"} 
        levelIndicator={{ level: values.level }} 
        adminbuttons={[
          <Button color="danger" 
           type="button" 
           onClick={() => {
             if(values.type === "song"){
               navigate(`/song/${values.slug}`)
             }
             else{
               navigate(`/fact/${values.slug}`)
             }
           }}
         >View</Button>
       ]}/>
      <Element style={{ marginTop: 5, marginBottom: 5 }}>
        <Field>
          <Label>Revisions</Label>
          <Control>
            <RevisionPicker slug={values.slug} value={currentRevisionId} onChange={setCurrentRevisionId} />
          </Control>
        </Field>
      </Element>
      <ContentTabs active={currentTab} onTabClick={setCurrentTab}>
        <Tab label="Properties">
          <Content>
            <Section>
              <Field>
                <Label>Page title</Label>
                <Control>
                  <Input onChange={handleChange} name="title" type="text" placeholder="The title of the song" value={values.title ?? ""} />
                </Control>
              </Field>
              <Field>
                <Label>Decription</Label>
                <Control>
                  <Input onChange={handleChange} name="description" type="text" placeholder="Song description" value={values.description ?? ""} />
                </Control>
              </Field>
              <Field>
                <Label>Slug</Label>
                <Control>
                  <Input disabled name="slug" type="text" placeholder="Unique identifier for this song in the URL" value={values.slug} />
                </Control>
              </Field>
              <Field>
                <Label>Difficulty</Label>
                <Control>
                  <Select onChange={(e) => handleChange(e, "Int32")} name="level" value={values.level ?? undefined}>
                    <option>Select</option>
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                    <option value="5">5</option>
                  </Select>
                </Control>
              </Field>
              {values.type === "fact" &&
                <Switch name={'skipInstrumentTransponation'} label={'Skip instrument transponation'} checked={values.skipInstrumentTransponation} onChange={(e) => handleChange(e, "Boolean")} />
              }
              {/*               <Field>
                <Label>Type</Label>
                <Control>
                  <Select name="type" onChange={handleChange} value={values.type ?? "song"}>
                    <option value="song">Song</option>
                    <option value="fact">Fact</option>
                  </Select>
                </Control>
              </Field> */}
              {values.type === "song" &&
                <>
                  <Field >
                    <Control>
                      <Label>Key tonic</Label>
                      <KeyTonicPicker name="keytonic" onChange={handleChange} value={values.keytonic ?? ""} />
                    </Control>
                  </Field>
                  <Field >
                    <Label>Chord chart </Label>
                    <Control>
                      {/* <a onClick={insertSongTemplate}>Insert template</a> */}
{/*                       <Button
                        color=""
                        renderAs="span"
                        size='small' 
                        marginless={true} 
                        onClick={() => pasteTemplate()}
                      >
                        <b>Insert template</b>
                      </Button> */}
                      <MarkdownTextareaAC ref={chordChartRef} name="content" placeholder="Textarea" value={values.content ?? ""} onChange={handleChange} pageSlug={slug}/>
                    </Control>
                  </Field>
                  <SheetContainer title={values.title}>
                    <Markdown objectProps={{ keytonic: values.keytonic }}>{values.content}</Markdown>
                  </SheetContainer>
                </>
              }

              {/* <Field kind="group" >
                <Control>
                  <Label>MIDI file</Label>
                  <InputFile icon={<Icon icon="upload" />} boxed placeholder="Textarea" />
                  <Icon><FontAwesomeIcon icon={faMusic} /></Icon>&nbsp;All_of_me.midi
                </Control>
                <Control>
                  <Label>AUDIO file (slow)</Label>
                  <InputFile icon={<Icon icon="upload" />} boxed placeholder="Textarea" />
                  <Icon><FontAwesomeIcon icon={faFileAudio} /></Icon>&nbsp;All_of_me_Slow.mp3
                </Control>
                <Control>
                  <Label>AUDIO file (normal)</Label>
                  <InputFile icon={<Icon icon="upload" />} boxed placeholder="Textarea" />
                  <Icon><FontAwesomeIcon icon={faFileAudio} /></Icon>&nbsp;All_of_me.mp3
                </Control>
              </Field> */}
            </Section>

          </Content>
        </Tab>

        <Tab label="Steps">
          {values.steps && values.steps.length === 0 &&
            <Button color="info" type="button" onClick={addStep}>Add new step</Button>
          }
          {values.steps && values.steps.length > 0 &&
            <>
              <Steps noOfSteps={values.steps.length} active={currentStep} setCurrentStep={setCurrentStep} />
              <Field kind="group" >
                <Control>
                  <Select name="stepOrder" value={currentStep} onChange={handleStepOrder}>
                    {values.steps.map((_, index) => (
                      <option value={index + 1} key={index}>Position: {index + 1}</option>
                    ))}
                  </Select>
                </Control>
                <Control>
                  <Button color="danger" type="button" onClick={deleteStep}>Delete step</Button>
                </Control>
                <Control>
                  <Button color="info" type="button" onClick={addStep}>Add new step</Button>
                </Control>
              </Field>
              <StepContentEdit
                step={values.steps[currentStep - 1]}
                statePrefix={`steps[${currentStep - 1}]`}
                handleChange={handleChange} 
                skipInstrumentTransponation={values.skipInstrumentTransponation}
                pageSlug={slug}/>

              {values.type === "song" ?
                <ContentTabs active={currentStepTab} onTabClick={setCurrentStepTab}>
                  <Tab label="Chord chart">
                    <Section>
                      <i>Edit chord chart under 'Properties'</i><br />
                      <ScoreMarks display={inView} ref={scoreMarksRef} statePrefix={`steps[${currentStep - 1}]`} values={values.steps[currentStep - 1].scoremarks} handleChange={handleChange} songSheetCursor={ {songSheetCursor: songSheetCursor, setSongSheetCursor: setSongSheetCursor} }/>
                      <div ref={ref} style={{ cursor: songSheetCursor==='roller'?'url(/paint-roller-solid.png),auto':songSheetCursor}}> 
                      <SheetContainer title={values.title} >
                        <Markdown objectProps={
                          { keytonic: values.keytonic, 
                            scoreProps: { onChordClick: onChordClick, scoremarks: values.steps[currentStep - 1].scoremarks }
                          }
                        }>{values.content}</Markdown>
                      </SheetContainer>
                      </div>
                    </Section>
                  </Tab>
                  <Tab label="Practice">
                    <Section>
                      <SortablePracticeStack
                        practices={values.steps[currentStep - 1].practice}
                        statePrefix={`steps[${currentStep - 1}].practice`}
                        handleChange={handleChange}
                        handleDeletePractice={deletePractice}
                        onDrop={onDrop} 
                        />

                    </Section>
                    <Section>
                      <Field>
                        <Control>
                          <Button color="info" type="button" onClick={addPractice}>Add practice</Button>
                        </Control>
                      </Field>
                    </Section>
                  </Tab>
                </ContentTabs>
                :
                <>
                  <Section>
                    <SortablePracticeStack
                      practices={values.steps[currentStep - 1].practice}
                      statePrefix={`steps[${currentStep - 1}].practice`}
                      handleChange={handleChange}
                      handleDeletePractice={deletePractice}
                      onDrop={onDrop} 
                      skipInstrumentTransponation={values.skipInstrumentTransponation}/>

                  </Section>
                  <Section>
                    <Field>
                      <Control>
                        <Button color="info" type="button" onClick={addPractice}>Add practice</Button>
                      </Control>
                    </Field>
                  </Section>
                </>
              }
            </>
          }
        </Tab>
      </ContentTabs>
      <div className="is-divider"></div>
      <Section>
        <Field>
          <Label>Comment</Label>
          <Control>
            <Input onChange={handleChange} name="revisionComment" type="text" value={values.revisionComment ?? ""} />
          </Control>
        </Field>
        {/* TODO make button group responsive */}
        <Field kind="group">
          <Control>
            <Button color="danger" type="button" onClick={null}>TODO Delete</Button>
          </Control>
          <Control>
            <Button color="danger" type="button" onClick={handleUnpublish}>Unpublish</Button>
          </Control>
          <Control>
            <Button color="primary" type="button" onClick={handlePublish}>Publish</Button>
          </Control>
          <Control>
            <Button color="success" type="button" onClick={handleSave}>Save draft</Button>
          </Control>
          <Control>
            <Button type="button" onClick={() => {
              navigate(`/song/${values.slug}`)
            }}>View</Button>
          </Control>
        </Field>
        <Container>&nbsp;<br/>&nbsp;</Container>
      </Section>
      {false &&
        <>
          <code><pre>{JSON.stringify(values, undefined, 2)}</pre></code>
          <code><pre>{JSON.stringify(cleanFormValues(), undefined, 2)}</pre></code>
        </>
      }
      {/* <Confirm show={showPracticeDeleteModal} onQuit={closeModal} modal={{ closeOnBlur: true }}/> */}
    </Fragment>
  );
}

export default SongEdit;
